import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import {
  UseFormGetValues,
  UseFormReset,
  UseFormSetValue
} from 'react-hook-form';
import { getEmployeeMasterList } from '../../apicalls/employeeMaster';
import { TSelectItem } from '../../types/common';
import { checkResData } from '../../utils/common';
import { EMPLOYEE_STATUS } from '../../const/Const';
// import { TSearchForm } from './index';

export type TProps = {
  setValue: UseFormSetValue<any>;
  getValues: UseFormGetValues<any>;
  reset: UseFormReset<any>;
};

export const useHooks = (props: TProps) => {
  const { setValue, getValues, reset } = props;

  // snackbar
  const { enqueueSnackbar } = useSnackbar();

  // 担当者のセレクトボックの初期値
  const defaultSelectListVal = { value: 0, label: '--' };

  // 担当者選択リスト
  const [employeeList, setEmployeeList] = useState<TSelectItem[]>([]);
  const [inactiveEmployeeList, setInactiveEmployeeList] = useState<
    TSelectItem[]
  >([]);

  // 選択した担当者ID
  const [employeeId, setEmployeeId] = useState(0);
  // 担当者選択時のハンドラ
  const handleOnChangeEmployeeId = () => {
    const selectedEmployeeId = getValues('charge_user_id')?.value;
    if (selectedEmployeeId) {
      setEmployeeId(Number(selectedEmployeeId));
      // 担当者IDが該当する担当を担当選択プルダウンにセット
      employeeList.forEach((employee: { value: number; label: string }) => {
        if (employee.value === selectedEmployeeId) {
          setValue('charge_user_id', employee);
        }
      });
    } else {
      setEmployeeId(0);
      setValue('charge_user_id', defaultSelectListVal);
    }
  };

  // URL発行モーダル
  const [isOpenPublishUrlModal, setIsOpenPublishUrlModal] = useState(false);
  const handleClickPublishUrlButton = () => {
    setIsOpenPublishUrlModal(true);
  };

  // 担当者取得処理（初回のみ）
  useEffect(() => {
    // 担当者選択プルダウン
    // 担当者一覧を取得
    getEmployeeMasterList('', 1).then((resData: any) => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        let activeEmployeeList = [];
        let inactiveEmployeeList = [];
        if (data) {
          activeEmployeeList = data.data
            .filter(
              (employee: any) => employee.status === EMPLOYEE_STATUS.ACTIVE
            )
            .map((employee: any) => ({
              value: employee.id,
              label: employee.name ?? ''
            }));
          inactiveEmployeeList = data.data
            .filter(
              (employee: any) => employee.status === EMPLOYEE_STATUS.INACTIVE
            )
            .map((employee: any) => ({
              value: employee.id,
              label: employee.name ?? ''
            }));
        }
        setEmployeeList(activeEmployeeList);
        setInactiveEmployeeList(inactiveEmployeeList);
        setValue('charge_user_id', defaultSelectListVal);
        setEmployeeId(0);
        reset({
          user_id: defaultSelectListVal
        });
      });
    });
  }, []);

  return {
    employeeList,
    inactiveEmployeeList,
    employeeId,
    handleOnChangeEmployeeId,
    isOpenPublishUrlModal,
    setIsOpenPublishUrlModal,
    handleClickPublishUrlButton
  };
};
